import upload, { uploadEventDoc } from 'utils/fileUploader';
import _ from 'underscore';
import { matchPath } from 'react-router';
import {
  UPCOMING_EVENT_FILTERS,
  PAST_EVENT_FILTERS
} from 'constants/EventFilters';

import {
  GET_EVENT,
  GET_EVENT_CREW,
  GET_EVENT_ELIGIBLE_MEMBERS,
  START_EDITING_EVENT,
  START_CREATING_EVENT,
  START_DUPLICATING_EVENT,
  CANCEL_EDITING_EVENT,
  CANCEL_CREATING_EVENT,
  CANCEL_DUPLICATING_EVENT,
  UPDATE_EVENT,
  UPDATE_EVENT_PHOTO,
  GET_TEAM_EVENTS,
  GET_TEAM_ARCHIVE_EVENTS,
  SEARCH_TEAM_EVENTS,
  CLEAR_SEARCH_TEAM_EVENTS,
  UPDATE_EVENT_LABELS,
  CREATE_EVENT,
  ARCHIVE_EVENT,
  DUPLICATE_EVENT,
  DELETE_EVENT,
  RESTORE_EVENT,
  GET_EVENT_FS_OBJECT,
  GET_EVENT_FS_OBJECT_CHILDREN,
  SET_EVENT_FS_OBJECT_SORTING,
  DOWNLOAD_EVENT_FS_DOC,
  MOVE_EVENT_FS_OBJECT,
  MULTI_SELECT_FS_OBJECT,
  CREATE_FS_FOLDER,
  SEARCH_FS_OBJECTS,
  SEARCH_ARCHIVED_FS_OBJECTS,
  CLEAR_SEARCH_FS_OBJECTS,
  CLEAR_SEARCH_ARCHIVED_FS_OBJECTS,
  CREATE_FS_DOCS,
  CREATE_FS_DOC,
  CREATE_AND_INVITE_USERS,
  SET_UPLOAD_STATUS_VISIBILITY,
  UPDATE_EVENT_ROLE,
  CREATE_EVENT_ROLE,
  DELETE_EVENT_ROLE,
  RESEND_EVENT_INVITE,
  SEARCH_USER_EVENTS,
  CLEAR_SEARCH_USER_EVENTS,
  ARCHIVE_EVENT_FS_OBJECT,
  GET_ARCHIVED_EVENT_FS_OBJECTS,
  SET_ARCHIVED_EVENT_FS_OBJECT_SORTING,
  DELETE_EVENT_FS_OBJECT,
  RESTORE_EVENT_FS_OBJECT,
  UPDATE_FOLDER,
  UPDATE_EVENT_DOC,
  UPDATE_EVENT_LABEL,
  UPDATE_AVAILABLE_TOOLS,
  INVITE_CREW_BY_EMAIL,
  GET_TEAM_PAST_EVENTS
} from 'actions/Types';

import { clearModal } from './index';
import { INVITE_CREW_MODAL } from 'constants/ModalTypes';

import { push } from 'connected-react-router';

import Paths from 'AppPaths';
import {
  hasEventRouteState,
  getUngreedyEventRouteMatch,
  getCurrentTeamId,
  withCurrentParams,
  getCurrentUserId,
  isAdminForTeam,
  getEventTeam
} from './utils';

import { updateUserLatestRoles } from 'actions/User';

import { showNotification } from 'actions';

import { AVAILABLE_TOOLS } from 'constants/AvailableTools';
import { UploadStatusMessages } from 'constants/EventDocUploadStatuses';
import VideoRenditionTypes from 'constants/videoRenditionsTypes';

export const removeFSObject = objectId => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: DELETE_EVENT_FS_OBJECT,
      request: async apiClient => {
        const result = await apiClient.eventFileSystemObject.delete(
          teamId,
          eventId,
          objectId
        );

        dispatch(getArchivedFSObjects());

        dispatch(showNotification('Your file has been permanently deleted!'));

        return result;
      }
    };

    dispatch(action);
  });
};

export const restoreFSObject = objectId => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: RESTORE_EVENT_FS_OBJECT,
      request: async apiClient => {
        const result = await apiClient.eventFileSystemObject.restoreArchive(
          teamId,
          eventId,
          objectId
        );

        dispatch(getArchivedFSObjects());

        return result;
      }
    };

    dispatch(action);
  });
};

export const archiveFSObject = objectId => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: ARCHIVE_EVENT_FS_OBJECT,
      request: async apiClient => {
        const result = await apiClient.eventFileSystemObject.archive(
          teamId,
          eventId,
          objectId
        );

        dispatch(getCurrentFSObjectChildren());

        return result;
      }
    };

    dispatch(action);
  });
};

export const getArchivedFSObjects = () => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: GET_ARCHIVED_EVENT_FS_OBJECTS,
      request: async apiClient => {
        return await apiClient.eventFileSystemObject.getExplicitlyArchived(
          teamId,
          eventId,
          {
            page: 1,
            size: 500
          }
        );
      }
    };

    dispatch(action);
  });
};

export const createAndInviteUsers = (users, role) => {
  return dispatch => {
    const action = {
      type: CREATE_AND_INVITE_USERS,
      request: async apiClient => {
        await Promise.all(
          users.map(async u => {
            let user = u.user;
            if (!user) {
              const result = await apiClient.user.findOrCreatePendingByEmail({
                emails: [u.email]
              });
              user = result[0];
            }

            dispatch(createRoleInCurrentEvent(user._id, role));
          })
        );
      }
    };

    dispatch(action);
  };
};

export const inviteCrewByEmail = users => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: INVITE_CREW_BY_EMAIL,
      request: async apiClient => {
        const result = await apiClient.event.inviteCrewByEmail(
          teamId,
          eventId,
          { users }
        );

        dispatch(getCurrentEventCrew());
        dispatch(clearModal(INVITE_CREW_MODAL));

        return result;
      }
    };

    dispatch(action);
  });
};

export const getEligibleMembers = () => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: GET_EVENT_ELIGIBLE_MEMBERS,
      request: async apiClient => {
        const users = await apiClient.event.getEligibleMembers(teamId, eventId);

        return users;
      }
    };

    dispatch(action);
  });
};

export const showEventUploadStatus = () => {
  return dispatch => {
    const action = {
      type: SET_UPLOAD_STATUS_VISIBILITY,
      payload: true
    };

    dispatch(action);
  };
};

export const toggleEventUploadStatus = () => {
  return (dispatch, getState) => {
    const { eventUploadStatusVisibility } = getState();

    const action = {
      type: SET_UPLOAD_STATUS_VISIBILITY,
      payload: eventUploadStatusVisibility ? false : true
    };

    dispatch(action);
  };
};

/**
 * Start editing event settings
 *
 * @param {} event
 */
export const startEditingEvent = event => {
  return dispatch => {
    const action = {
      type: START_EDITING_EVENT,
      payload: event
    };

    dispatch(action);
  };
};

export const startCreatingEvent = () => {
  return (dispatch, getState) => {
    const teamId = getCurrentTeamId(getState);
    const action = {
      type: START_CREATING_EVENT,
      payload: { team: { _id: teamId } }
    };

    dispatch(action);
  };
};

export const startDuplicatingEvent = event => {
  return dispatch => {
    const action = {
      type: START_DUPLICATING_EVENT,
      payload: event
    };

    dispatch(action);
  };
};

export const cancelEditingEvent = () => {
  return dispatch => {
    const action = {
      type: CANCEL_EDITING_EVENT
    };

    dispatch(action);
  };
};

export const cancelCreatingEvent = () => {
  return dispatch => {
    const action = {
      type: CANCEL_CREATING_EVENT
    };

    dispatch(action);
  };
};

export const cancelDuplicatingEvent = () => {
  return dispatch => {
    const action = {
      type: CANCEL_DUPLICATING_EVENT
    };

    dispatch(action);
  };
};

export const createEvent = (teamId, eventSettings, photoFile, labels) => {
  return dispatch => {
    const action = {
      type: CREATE_EVENT,
      request: async apiClient => {
        const eventForPayload = _.omit(eventSettings, 'owner');

        const event = await apiClient.event.create(teamId, {
          ownerId: eventSettings.owner,
          event: { ...eventForPayload, team: teamId }
        });

        if (photoFile && event && event._id) {
          dispatch(updateEventPhoto(teamId, event._id, photoFile));
        }

        if (labels && labels.length && event && event._id) {
          //TODO: migrate to _updateLabels
          dispatch(updateEventLabels(teamId, event._id, labels));
        }

        // We assume that createEvent always happens in the context of the 'Upcoming' tab
        // https://shoflo.slack.com/archives/C02N52PS5/p1559852833061200
        dispatch(getTeamEvents(UPCOMING_EVENT_FILTERS));

        return event;
      }
    };

    dispatch(action);
  };
};

export const duplicateEvent = (
  teamId,
  eventId,
  eventSettings,
  photoFile,
  labels
) => {
  return dispatch => {
    const action = {
      type: DUPLICATE_EVENT,
      request: async apiClient => {
        const eventForCreatePayload = _.pick(eventSettings, [
          'title',
          'startOn',
          'endOn'
        ]);
        let event = await apiClient.event.duplicate(
          teamId,
          eventId,
          eventForCreatePayload
        );

        await apiClient.event.updateOwner(teamId, event._id, {
          owner: eventSettings.owner
        });

        const eventForUpdatePayload = _.omit(eventSettings, 'owner');

        event = await apiClient.event.update(
          teamId,
          event._id,
          eventForUpdatePayload
        );

        if (photoFile) {
          event = await _updatePhoto(teamId, event._id, photoFile);
        }

        if (labels && labels.length) {
          event = await _updateLabels(apiClient, teamId, event._id, labels);
        }

        dispatch(getTeamEvents());

        return event;
      }
    };

    dispatch(action);
  };
};

export const updateEventLabels = (teamId, eventId, labels) => {
  return dispatch => {
    const action = {
      type: UPDATE_EVENT_LABELS,
      request: async apiClient => {
        return await _updateLabels(apiClient, teamId, eventId, labels);
      }
    };

    dispatch(action);
  };
};

export const updateCurrentEvent = (changes, photoFile, labels) => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    dispatch(updateEvent(teamId, eventId, changes, photoFile, labels));
  });
};

export const updateEvent = (
  teamId,
  eventId,
  changes,
  photoFile = null,
  labels
) => {
  return dispatch => {
    const action = {
      type: UPDATE_EVENT,
      request: async apiClient => {
        if (photoFile) {
          dispatch(updateEventPhoto(teamId, eventId, photoFile));
        }

        if (changes.owner) {
          await apiClient.event.updateOwner(teamId, eventId, {
            owner: changes.owner
          });
        }

        const eventChanges = _.omit(changes, 'owner');
        const event = await apiClient.event.update(
          teamId,
          eventId,
          eventChanges
        );

        if (labels) {
          await _updateLabels(apiClient, teamId, eventId, labels);
        }

        dispatch(getTeamEvents());

        return event;
      }
    };

    dispatch(action);
  };
};

export const archiveEvent = eventIdOrObj => {
  const eventId =
    typeof eventIdOrObj === 'string' ? eventIdOrObj : eventIdOrObj._id;

  return (dispatch, getState) => {
    const teamId = getEventTeam(eventIdOrObj, getState);

    const action = {
      type: ARCHIVE_EVENT,
      request: async apiClient => {
        const result = await apiClient.event.archive(teamId, eventId);

        dispatch(getUpcomingTeamEvents());

        return result;
      }
    };

    dispatch(action);
  };
};

export const restoreEvent = eventIdOrObj => {
  const eventId =
    typeof eventIdOrObj === 'string' ? eventIdOrObj : eventIdOrObj._id;

  return (dispatch, getState) => {
    const action = {
      type: RESTORE_EVENT,
      request: async apiClient => {
        const result = await apiClient.event.restore(
          getCurrentTeamId(getState),
          eventId
        );

        dispatch(getArchivedTeamEvents());

        return result;
      }
    };

    dispatch(action);
  };
};

export const deleteEvent = eventId => {
  return (dispatch, getState) => {
    const action = {
      type: DELETE_EVENT,
      request: async apiClient => {
        const result = await apiClient.event.hardDelete(
          getCurrentTeamId(getState),
          eventId
        );

        dispatch(getArchivedTeamEvents());

        return result;
      }
    };

    dispatch(action);
  };
};

export const updateEventPhoto = (teamId, eventId, file) => {
  return dispatch => {
    const action = {
      type: UPDATE_EVENT_PHOTO,
      request: async () => {
        const result = await _updatePhoto(teamId, eventId, file);

        dispatch(getTeamEvents());

        return result;
      }
    };

    dispatch(action);
  };
};

/**
 * Get an event
 *
 */
export const getEvent = (teamId, eventId) => {
  return (dispatch, getState) => {
    const action = {
      type: GET_EVENT,
      request: async apiClient => {
        const event = await apiClient.event.get(teamId, eventId);

        //update latest user roles
        const { user } = getState();
        if (user) {
          const { events, teams } = user;
          const changes = {};
          const latestEventRole = events.find(
            eventRole => eventRole.event?.toString() === eventId?.toString()
          );
          if (
            latestEventRole &&
            !_.isEqual(latestEventRole, user.lastEventRole)
          ) {
            changes.lastEventRole = latestEventRole;
          }
          const latestTeamRole = teams.find(
            teamRole => teamRole.team?.toString() === teamId?.toString()
          );
          if (latestTeamRole && !_.isEqual(latestTeamRole, user.lastTeamRole)) {
            changes.lastTeamRole = latestTeamRole;
          }

          if (Object.keys(changes).length > 0) {
            dispatch(updateUserLatestRoles(user._id, changes));
          }
        }

        //format event labels
        if (event && event.labels) {
          const formattedLabels = event.labels.map(label => {
            return { _id: label };
          });
          event.labels = formattedLabels;
        }

        return event;
      }
    };

    dispatch(action);
  };
};

/**
 * Get the crew for the current event
 */
export const getCurrentEventCrew = () => {
  return (dispatch, getState) => {
    const match = getUngreedyEventRouteMatch(getState);

    const { teamId, eventId } = match.params;

    const action = {
      type: GET_EVENT_CREW,
      request: async apiClient => {
        const roles = await apiClient.event.getRoles(teamId, eventId);

        return _.uniq(roles, false, _.property('_id'));
      }
    };

    dispatch(action);
  };
};

/**
 *
 * Resend an invite for a pending user
 *
 * @param {*} userId
 */
export const resendInviteInCurrentEvent = userId => {
  return (dispatch, getState) => {
    const match = getUngreedyEventRouteMatch(getState);

    const { teamId, eventId } = match.params;

    const action = {
      type: RESEND_EVENT_INVITE,
      request: async apiClient => {
        return await apiClient.event.resendInviteEmail(teamId, eventId, userId);
      },
      payload: {
        teamId,
        eventId,
        userId
      }
    };

    dispatch(action);
  };
};

/**
 * Delete a role in the current event
 *
 * @param {*} userId
 */
export const deleteRoleInCurrentEvent = userId => {
  return (dispatch, getState) => {
    const match = getUngreedyEventRouteMatch(getState);

    const { teamId, eventId } = match.params;
    const { eventCrew } = getState();

    const user = eventCrew ? eventCrew.filter(u => u._id === userId)[0] : {};

    const action = {
      type: DELETE_EVENT_ROLE,
      request: async apiClient => {
        return await apiClient.event.deleteRole(userId, eventId, teamId);
      },
      payload: {
        teamId,
        eventId,
        userId
      }
    };

    dispatch(action);

    dispatch(
      showNotification(
        `${user.firstName} ${user.lastName} has been successfully removed from this event!`
      )
    );
  };
};

/**
 * Change the role of a user in an event
 *
 * @param {*} roleId
 * @param {*} userId
 * @param {*} newRoleValue
 */
export const updateRoleInCurrentEvent = (roleId, userId, newRoleValue) => {
  return (dispatch, getState) => {
    if (!roleId) {
      return dispatch(createRoleInCurrentEvent(userId, newRoleValue));
    }

    const match = getUngreedyEventRouteMatch(getState);

    const { teamId, eventId } = match.params;
    const { eventCrew } = getState();

    const user = eventCrew ? eventCrew.filter(u => u._id === userId)[0] : {};

    const action = {
      type: UPDATE_EVENT_ROLE,
      request: async apiClient => {
        const result = await apiClient.event.updateRole(
          teamId,
          eventId,
          roleId,
          {
            role: newRoleValue,
            userId
          }
        );

        dispatch(getCurrentEventCrew());

        return result;
      },
      payload: {
        roleId,
        userId,
        newRoleValue
      }
    };

    dispatch(action);

    dispatch(
      showNotification(
        `${user.firstName} ${user.lastName}'s permission level has been changed!`
      )
    );
  };
};

/**
 * Create role in an event
 *
 * @param {*} userId
 * @param {*} newRoleValue
 */
export const createRoleInCurrentEvent = (userId, newRoleValue) => {
  return (dispatch, getState) => {
    const match = getUngreedyEventRouteMatch(getState);

    const { teamId, eventId } = match.params;

    const action = {
      type: CREATE_EVENT_ROLE,
      request: async apiClient => {
        const result = await apiClient.event.createRole(teamId, eventId, {
          role: newRoleValue,
          userId
        });

        dispatch(getCurrentEventCrew());

        return result;
      },
      payload: {
        userId,
        newRoleValue
      }
    };

    dispatch(action);
  };
};

export const getUpcomingTeamEvents = () => {
  return dispatch => {
    dispatch(getTeamEvents(UPCOMING_EVENT_FILTERS));
  };
};

/**
 * Get the events for a team
 *
 * TODO: move this to team, or move the User getEvents action here...it is not consistent to have this here and have
 * getEvents in the User action module
 */
export const getTeamEvents = query => {
  return (dispatch, getState) => {
    const teamId = getCurrentTeamId(getState);

    if (!teamId || !isAdminForTeam(getState)) {
      const action = {
        type: GET_TEAM_EVENTS,
        payload: []
      };
      return dispatch(action);
    }

    if (!query) {
      query = UPCOMING_EVENT_FILTERS;
    }

    const action = {
      type: GET_TEAM_EVENTS,
      request: async apiClient => {
        const teamEvents = await apiClient.event.getByTeamId(teamId, {
          ...query,
          size: 200
        });

        return teamEvents;
      }
    };

    dispatch(action);
  };
};

export const getPastTeamEvents = (page = 1) => {
  return (dispatch, getState) => {
    const teamId = getCurrentTeamId(getState);

    if (!teamId || !isAdminForTeam(getState)) {
      const action = {
        type: GET_TEAM_PAST_EVENTS,
        payload: {}
      };
      return dispatch(action);
    }
    const query = PAST_EVENT_FILTERS;

    const action = {
      type: GET_TEAM_PAST_EVENTS,
      request: async apiClient => {
        const {
          items: pastEvents,
          itemCount,
          pageCount
        } = await apiClient.event.getByTeamId(teamId, {
          ...query,
          page,
          size: 30,
          sortBy: { startOn: -1 }
        });

        return {
          events: pastEvents,
          itemCount,
          pageCount,
          page
        };
      }
    };

    dispatch(action);
  };
};

export const getArchivedTeamEvents = (page = 1) => {
  return (dispatch, getState) => {
    const teamId = getCurrentTeamId(getState);

    if (!teamId || !isAdminForTeam(getState)) {
      const action = {
        type: GET_TEAM_ARCHIVE_EVENTS,
        payload: {}
      };
      return dispatch(action);
    }

    const action = {
      type: GET_TEAM_ARCHIVE_EVENTS,
      request: async apiClient => {
        const {
          items: archivedItems,
          itemCount,
          pageCount
        } = await apiClient.event.getArchivedEventsByTeamId(teamId, {
          page,
          size: 30, // default number of items per page desired
          sortBy: { startOn: -1 }
        });

        return {
          events: archivedItems,
          itemCount,
          pageCount,
          page
        };
      }
    };

    dispatch(action);
  };
};

/**
 * Get FS Object (just one)
 */
export const getFSObject = (teamId, eventId, objectId) => {
  return dispatch => {
    const action = {
      type: GET_EVENT_FS_OBJECT,
      request: async apiClient => {
        const fsObject = await apiClient.eventFileSystemObject.get(
          teamId,
          eventId,
          objectId
        );

        return fsObject;
      }
    };

    dispatch(action);
  };
};

export const getFSObjectByPath = (teamId, eventId, parentPath, objectName) => {
  return dispatch => {
    const action = {
      type: GET_EVENT_FS_OBJECT,
      request: async apiClient => {
        const query = {
          name: objectName
        };

        if (parentPath) {
          query.parentPath = parentPath;
        }

        //the 3rd argument is not used, need to fix in api.v2, but in the meantime, setting as undefined works
        const fsObject = await apiClient.eventFileSystemObject.getByPath(
          teamId,
          eventId,
          undefined,
          query
        );

        dispatch(
          push(`/dash/team/${teamId}/event/${eventId}/folder/${fsObject._id}`)
        );

        return fsObject;
      }
    };

    dispatch(action);
  };
};

export const getCurrentFSObjectChildren = () => {
  return (dispatch, getState) => {
    if (hasEventRouteState(getState)) {
      const match = getUngreedyEventRouteMatch(getState);

      const { teamId, eventId, folderId } = match.params;

      dispatch(getFSObjectChildren(teamId, eventId, folderId));
    } else {
      throw new Error(
        'getCurrentFSObjectChildren but it appears the current route does not have the necessary parameters'
      );
    }
  };
};

/**
 * Get FS Object children
 */
export const getFSObjectChildren = (teamId, eventId, parentId) => {
  return (dispatch, getState) => {
    const { eventFSObjectsSorting } = getState();

    const action = {
      type: GET_EVENT_FS_OBJECT_CHILDREN,
      request: async apiClient => {
        const fsObjects = await apiClient.eventFileSystemObject.getChildren(
          teamId,
          eventId,
          {
            parentId,
            page: 1,
            size: 500,
            ...eventFSObjectsSorting
          }
        );

        return fsObjects;
      }
    };

    dispatch(action);
  };
};

export const moveFSObjects = (teamId, eventId, objectIdsToMove, parentId) => {
  return (dispatch, getState) => {
    const action = {
      type: MOVE_EVENT_FS_OBJECT,
      request: async apiClient => {
        //If there is a parentId, call the move method, if not, call the moveToRoot method
        const method = parentId ? 'move' : 'moveToRoot';

        //Iterate, and move each one
        const result = await Promise.all(
          objectIdsToMove.map(objId => {
            const args = [teamId, eventId, objId];

            if (parentId) {
              args.push(parentId);
            }

            return apiClient.eventFileSystemObject[method].apply(
              apiClient,
              args
            );
          })
        );

        //Try to match URL params from location state
        const { router, selectedEventFSFolder } = getState();

        const pathName = router.location.pathname;

        const eventMatch = matchPath(pathName, {
          path: Paths.EventDash
        });

        //If there is a match, refetch the files, since we want to refresh after having moved one or more objects
        if (eventMatch) {
          const {
            teamId: matchTeamId,
            eventId: matchEventId,
            folderId: matchFolderId
          } = eventMatch.params;
          const currentFolderId = selectedEventFSFolder
            ? selectedEventFSFolder._id
            : matchFolderId;
          dispatch(
            getFSObjectChildren(matchTeamId, matchEventId, currentFolderId)
          );
        }

        return result;
      }
    };

    dispatch(action);
  };
};

export const moveFSObjectsToPath = (
  teamId,
  eventId,
  objectIdsToMove,
  parentPath,
  objectName
) => {
  return dispatch => {
    const action = {
      type: MOVE_EVENT_FS_OBJECT,
      request: async apiClient => {
        const query = {
          name: objectName
        };

        if (parentPath) {
          query.parentPath = parentPath;
        }

        const fsObjectTarget = await apiClient.eventFileSystemObject.getByPath(
          teamId,
          eventId,
          undefined,
          query
        );

        dispatch(
          moveFSObjects(teamId, eventId, objectIdsToMove, fsObjectTarget._id)
        );

        return {};
      }
    };

    dispatch(action);
  };
};

export const downloadFSDoc = (teamId, eventId, docId) => {
  return dispatch => {
    const action = {
      type: DOWNLOAD_EVENT_FS_DOC,
      request: async apiClient => {
        const $window = window.open('');

        const { url } = await apiClient.eventDoc.getSignedUrlPublic(
          teamId,
          eventId,
          docId,
          { videoURLType: VideoRenditionTypes.MP4 }
        );

        $window.location.assign(url);

        return url;
      }
    };

    dispatch(action);
  };
};

export const multiSelectFSObject = fsObjectId => {
  return dispatch => {
    const action = {
      type: MULTI_SELECT_FS_OBJECT,
      payload: fsObjectId
    };

    dispatch(action);
  };
};

/**
 * Set the sorting config for event fs list
 * @param {*} sorting
 */
export const setFSObjectSorting = sorting => {
  return dispatch => {
    const action = {
      type: SET_EVENT_FS_OBJECT_SORTING,
      payload: sorting
    };

    dispatch(action);
  };
};

export const setArchivedFSObjectSorting = sorting => {
  return dispatch => {
    const action = {
      type: SET_ARCHIVED_EVENT_FS_OBJECT_SORTING,
      payload: sorting
    };

    dispatch(action);
  };
};

/**
 * Create an FS Folder
 *
 * @param {*} teamId
 * @param {*} eventId
 * @param {*} name
 * @param {*} description
 */
export const createFolder = (teamId, eventId, name, description) => {
  return (dispatch, getState) => {
    const { selectedEventFSFolder } = getState();
    const requestPayload = {
      name,
      description,
      isDirectory: true
    };

    if (selectedEventFSFolder) {
      requestPayload.parentId = selectedEventFSFolder._id;

      let parentNodeString = '';
      if (selectedEventFSFolder.parentPath) {
        parentNodeString = `${selectedEventFSFolder.parentPath},`;
      }

      requestPayload.parentPath = `${parentNodeString}${selectedEventFSFolder.name}`;
    }

    const action = {
      type: CREATE_FS_FOLDER,
      request: async apiClient => {
        const newFolder = await apiClient.eventFileSystemObject.createFolder(
          teamId,
          eventId,
          requestPayload
        );
        //refresh current folder
        dispatch(getFSObjectChildren(teamId, eventId, requestPayload.parentId));
        dispatch(clearModal('CREATE_FS_FOLDER'));

        return newFolder;
      }
    };

    dispatch(action);
  };
};

export const searchUserEvents = (term, filter) => {
  const query = Object.assign({ term }, filter);

  return (dispatch, getState) => {
    const action = {
      type: SEARCH_USER_EVENTS,
      request: async apiClient => {
        const results = await apiClient.event.searchUserEvents(
          getCurrentUserId(getState),
          query
        );

        return results;
      }
    };

    dispatch(action);
  };
};

export const clearUserEventsSearchResults = () => {
  return dispatch => {
    const action = {
      type: CLEAR_SEARCH_USER_EVENTS
    };

    dispatch(action);
  };
};

export const searchTeamEvents = (term, filter) => {
  const query = Object.assign({ term }, filter);

  return (dispatch, getState) => {
    const action = {
      type: SEARCH_TEAM_EVENTS,
      request: async apiClient => {
        const results = await apiClient.event.searchTeamEvents(
          getCurrentTeamId(getState),
          query
        );

        return results;
      }
    };

    dispatch(action);
  };
};

export const clearTeamEventsSearchResults = () => {
  return dispatch => {
    const action = {
      type: CLEAR_SEARCH_TEAM_EVENTS
    };

    dispatch(action);
  };
};

export const searchFSObjects = (teamId, eventId, term) => {
  return dispatch => {
    const action = {
      type: SEARCH_FS_OBJECTS,
      request: async apiClient => {
        const results = await apiClient.eventFileSystemObject.search(
          teamId,
          eventId,
          { term }
        );

        return results;
      }
    };

    dispatch(action);
  };
};

export const searchArchivedFSObjects = (teamId, eventId, term) => {
  return dispatch => {
    const action = {
      type: SEARCH_ARCHIVED_FS_OBJECTS,
      request: async apiClient => {
        const results = await apiClient.eventFileSystemObject.search(
          teamId,
          eventId,
          //This will not work until we add api support for the `archived` flag
          { term, archived: true }
        );
        return results;
      }
    };
    dispatch(action);
  };
};

const { InvalidFile, FileTooLarge, UnsupportedFileType } = UploadStatusMessages;

export const uploadEventDocs = (teamId, eventId, files) => {
  return (dispatch, getState) => {
    const { selectedEventFSFolder } = getState();

    const parentId = selectedEventFSFolder && selectedEventFSFolder._id;

    const action = {
      type: CREATE_FS_DOCS,
      payload: files,
      request: async apiClient => {
        const result = await Promise.all(
          Array.from(files).map(async file => {
            let returnVal;

            try {
              returnVal = await uploadEventDoc(
                apiClient,
                teamId,
                eventId,
                file,
                parentId
              );
            } catch (error) {
              const { message } = error;

              const dispatchConfig = {
                type: `${CREATE_FS_DOC}_FAILURE`,
                payload: file
              };

              if (
                message &&
                [InvalidFile, FileTooLarge, UnsupportedFileType].includes(
                  message
                )
              ) {
                dispatchConfig.message = message;
              }

              dispatch(dispatchConfig);

              return;
            }

            dispatch({
              type: `${CREATE_FS_DOC}_SUCCESS`,
              payload: file
            });

            return returnVal;
          })
        );

        dispatch(getCurrentFSObjectChildren());

        return result;
      }
    };

    dispatch(action);
    dispatch(showEventUploadStatus());
  };
};

export const clearFSObjectsSearchResults = () => {
  return dispatch => {
    const action = {
      type: CLEAR_SEARCH_FS_OBJECTS
    };

    dispatch(action);
  };
};

export const clearArchivedFSObjectsSearchResults = () => {
  return dispatch => {
    const action = {
      type: CLEAR_SEARCH_ARCHIVED_FS_OBJECTS
    };

    dispatch(action);
  };
};

export const updateFolder = payload => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: UPDATE_FOLDER,
      request: async apiClient => {
        const folder = await apiClient.eventFileSystemObject.updateFolder(
          teamId,
          eventId,
          payload
        );

        dispatch(clearModal(UPDATE_FOLDER));
        dispatch(getCurrentFSObjectChildren());

        return folder;
      }
    };

    dispatch(action);
  });
};

export const updateEventDoc = (eventDocId, payload) => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: UPDATE_EVENT_DOC,
      request: async apiClient => {
        const eventDoc = await apiClient.eventDoc.update(
          teamId,
          eventId,
          eventDocId,
          payload
        );

        dispatch(clearModal(UPDATE_EVENT_DOC));
        dispatch(getCurrentFSObjectChildren());

        return eventDoc;
      }
    };

    dispatch(action);
  });
};

export const updateLabel = (teamId, eventId, labelId, payload) => {
  return dispatch => {
    const action = {
      type: UPDATE_EVENT_LABEL,
      request: async apiClient => {
        return await apiClient.event.updateLabel(
          teamId,
          eventId,
          labelId,
          payload
        );
      }
    };

    dispatch(action);
  };
};

export const updateAvailableTools = (user, availableTools, toolsDiff) => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: UPDATE_AVAILABLE_TOOLS,
      request: async apiClient => {
        await apiClient.event.updateAvailableTools(teamId, eventId, {
          userId: user._id,
          availableTools
        });

        dispatch(
          showNotification(
            `${AVAILABLE_TOOLS[toolsDiff]} has been updated for ${user.firstName} ${user.lastName}`
          )
        );
        return { userId: user._id, eventId, availableTools };
      }
    };
    dispatch(action);
  });
};

const _updateLabels = async (apiClient, teamId, eventId, labels) => {
  const event = await apiClient.event.updateLabels(teamId, eventId, { labels });

  return event;
};

const _updatePhoto = async (teamId, eventId, file) => {
  return await upload(
    '/api/upload/event.updatePhoto',
    { teamId, eventId },
    file
  );
};
